import { render, staticRenderFns } from "./SelectTransport.vue?vue&type=template&id=19f2725b"
import script from "./SelectTransport.vue?vue&type=script&lang=js"
export * from "./SelectTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports